module.exports = __webpack_public_path__ + "static/img/sendno.d1360d56.png";